import React, {Component} from 'react';
import './Exams.scss';
import * as constants from "../../../const/constants";
import Header from "../../../components/Header/Header";
import {Button, Card, Col, Container, Row} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {connect} from "react-redux";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../store/domain/classes/action";
import NotFound from "../../../components/NotFound/NotFound";
import {lang, language} from "../../../const/language";
import * as paperServicess from "../../../services/papers";
import {withRouter} from "react-router";
import moment from "moment";
import * as paperService from "../../../services/papers";
import {getCertificate} from "../../../services/papers";

class App extends Component {

    state = {
        allPapers: [],
    };

    componentDidMount() {
        this.getAllTriedPapers()
    }

    getAllTriedPapers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        const data = {
            "studentId": this.props.userObj.id
        };
        await paperServicess.viewTriedQuizzes(data)
            .then(response => {
                this.props.spinnerHandler(false);

                if (response.success) {
                    console.log(response.body);
                    this.setState({
                        allPapers: response.body
                    })
                } else {
                    commonFunc.notifyMessage(response.message, response.status);
                }
            })
    };


    viewLeaderBoard = (item) => {
        if (item.mapType === 'CLASS') {

            const data = {
                "classId": item.cid,
                "quizId": item.id,
                "flowType": true
            };
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`,
                state: {data}
            })
        } else {
            const data = {
                "courseId": item.cid,
                "quizId": item.id,
                "flowType":false
            };
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`,
                state: {data}
            })
        }
    };

    compareAnswers = (item) => {
        console.log(item)
        if (item.mapType === 'CLASS') {
            const data = {
                "classId": item.cid,
                "quizId": item.id,
                "enrollId": item.enrollId,
                "totalQuestions": item.noOfQuestions,
                "totalAnswers": item.noOfAnswersPerQuestion,
                "flowType": true
            };
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`,
                state: {data}
            })
        }else{
            const data = {
                "coursesId": item.cid,
                "quizId": item.id,
                "enrollId": item.enrollId,
                "totalQuestions": item.noOfQuestions,
                "totalAnswers": item.noOfAnswersPerQuestion,
                "flowType": false
            };
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`,
                state: {data}
            })
        }
    };

    checkAvailability = (item) => {
        const dt1 = new Date(item.startTime);
        const dt2 = new Date();

        let diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return (item.paperDuration + 15) > Math.abs(Math.round(diff));
    };


    joinPaper = async (paper) => {
        if (paper.mapType === 'CLASS') {
            this.props.spinnerHandler({isSpin: true, type: 15});
            const data = {
                "classEnrollId": paper.enrollId,
                "quizId": paper.id
            };
            await paperService.startQuize(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        localStorage.setItem("paper", res.body.questionPaperUrl);

                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${constants.HOME_START_ESSAY_SELECTED_PAPER_ROUTE}`,
                            state: {
                                ...paper,
                                pdfUrl: res.body.questionPaperUrl,
                                remaningTime: res.body.remainingTime,
                                logTime: new Date(),
                                flowType:true
                            }
                        })
                    } else {
                        commonFunc.notifyMessage(res.message);
                    }
                })
                .catch(error => {
                    //console.log(error)
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);

        }else{
            this.props.spinnerHandler({isSpin: true, type: 15});
            const data = {
                "courseEnrollId": paper.enrollId,
                "quizId": paper.id
            };
            await paperService.startQuize(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        localStorage.setItem("paper", res.body.questionPaperUrl);

                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${constants.HOME_START_ESSAY_SELECTED_PAPER_ROUTE}`,
                            state: {
                                ...paper,
                                pdfUrl: res.body.questionPaperUrl,
                                remaningTime: res.body.remainingTime,
                                logTime: new Date(),
                                flowType:false
                            }
                        })
                    } else {
                        commonFunc.notifyMessage(res.message);
                    }
                })
                .catch(error => {
                    //console.log(error)
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);


        }
    };

    checkTeacherComment = (item) => {
        console.log(item)
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_GET_TEACHER_COMMENT_ROUTE}`,
            state: {...item}
        })

    };

    shareCertificate = async (type) => {
        this.props.spinnerHandler(true);
        await paperServicess.getCertificate(this.props.userObj.id, type)
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    const element = document.createElement('a')
                    element.setAttribute('href', response.body.certificateBase64)
                    element.setAttribute('download', 'student_certificate.pdf')
                    document.body.appendChild(element)
                    element.click()
                } else {
                    commonFunc.notifyMessage(response.message, response.status);
                }
            })
    }

    render() {

        return (
            <div>
                <Header active={4}/>
                <main ref="main" className={"my-class"}>

                    <section>
                        <Container>
                            <div>
                                <h3 className={"teach-black-text head-topic align-center"}>{language[lang].triydPaperText}</h3>
                            </div>
                            {
                                this.state.allPapers.length === 0 &&
                                <NotFound/>
                            }
                            <div>

                                {this.state.allPapers.map((item, index) =>

                                    <div key={index}>
                                        <Row className={"view-papers row shadow "}>
                                            <Col lg="3">
                                                <Card className={"mark-wrapper"}>

                                                    <span className={"marks-labal"}>Marks</span>
                                                    {
                                                        item.quizType === 'MCQ' ?
                                                            <span
                                                                className={"mark-number"}>{item.marks + ' out of ' + item.noOfQuestions}</span> :
                                                            <span
                                                                className={"mark-number"}>{item.marks}</span>
                                                    }
                                                </Card>
                                            </Col>
                                            <Col sm={12} md={6} lg="6">
                                                <h2 className={"vp-topic"}>{item.title}</h2>
                                                {
                                                    item.startTime !== null &&
                                                    <p> {language[lang].tryDateText} {` ${moment(item.startTime.replace("Z", "")).format("YYYY MMM DD ")}`} , {` ${moment(item.startTime.replace("Z", "")).format("h mm a ")}`} </p>
                                                }

                                                {
                                                    item.endTime !== null &&
                                                    <p> {language[lang].submitDateText} {` ${moment(item.endTime.replace("Z", "")).format("YYYY MMM DD ")}`}, {` ${moment(item.endTime.replace("Z", "")).format("h mm a ")}`}</p>
                                                }
                                                {
                                                    item.answersState === 1 && <span
                                                        className={"submit-unsucces"}> {language[lang].suddenlyLeftText} </span>
                                                }
                                                {
                                                    item.answersState === 2 && <span
                                                        className={"submit-succes"}> {language[lang].sumbitedSuccesfullyText} </span>
                                                }
                                                {
                                                    item.mapType === 'CLASS' ? <span
                                                            className={"submit-succes"} style={{marginLeft:'15px'}}>{item.name}     පංතියට අදාළ ප්‍රශ්න පත්‍රයකි.</span>
                                                        : <span className={"submit-succes"} style={{marginLeft:'15px'}}>{item.name} පාඨමාලාවට අදාළ ප්‍රශ්න පත්‍රයකි.</span>
                                                }

                                            </Col>
                                            <Col lg="3">

                                                <a href={'https://docs.google.com/gview?embedded=true&url='+ item.questionPaperUrl} >

                                                    <Button className={" com-btn bold-text"}

                                                    >
                                                        {language[lang].viewPaperText}
                                                    </Button>
                                                </a>
                                                <Button className={" com-btn bold-text"}
                                                        onClick={() => this.viewLeaderBoard(item)}
                                                >
                                                    {language[lang].viewLeaderBoardText}
                                                </Button>
                                                {
                                                    item.quizType === 'MCQ' &&
                                                    <Button className={"com-btn bold-text"}
                                                            onClick={() => this.compareAnswers(item)}>
                                                        {language[lang].comapreAnswerText}
                                                    </Button>
                                                }

                                                {
                                                    (item.quizType !== 'MCQ' && this.checkAvailability(item)) &&
                                                    <Button className={"com-btn bold-text"}
                                                            onClick={() => this.joinPaper(item)}>
                                                        {language[lang].reSubmit}
                                                    </Button>
                                                }
                                                {
                                                    item.quizType === 'ESSAY' ?
                                                        <Button className={"com-btn bold-text"}
                                                                onClick={() => this.checkTeacherComment(item)}>
                                                            { language[lang].teacherComment}
                                                        </Button> : null
                                                }

                                                {
                                                    item.answersState === 2 &&
                                                    <Button className={"com-btn bold-text"}
                                                            onClick={() => this.shareCertificate("DOWNLOAD")}>
                                                        { language[lang].collectCertificate}
                                                    </Button>
                                                }
                                            </Col>

                                        </Row>


                                    </div>
                                )}

                            </div>

                            <div>

                                {this.state.allPapers === undefined && <NotFound/>}
                            </div>


                        </Container>
                    </section>
                </main>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    purchaseClasses: state.classes.purchaseClasses,
    userObj: state.student.userObj,
    isSpinner: state.spinner.isSpinner,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchAllPurchasedClass: data => dispatch(actionClassCreator.fetchAllPurchasedClass(data)),
    selectMyClassPagination: data => dispatch(actionClassCreator.selectMyClassPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
